import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozTime', bringozTime);

function bringozTime($filter, splitService, moment) {
  function doFilter(_date, timeZoneId, withSeconds) {
    const format = splitService.getDateAndTimeConfig().time || 'HH:mm';
    const timeFormat = withSeconds ? format.replace('mm', 'mm:ss') : format;

    if (timeZoneId) {
      return moment(_date).tz(timeZoneId).format(timeFormat);
    } else if (!timeZoneId) {
      return moment(_date).format(timeFormat);
    }
  }

  return function (object, ref, defaultValue, timeZoneId, withSeconds) {
    if (object && object[ref]) {
      return doFilter(object[ref], timeZoneId, withSeconds);
    } else {
      if (_.isUndefined(defaultValue)) {
        defaultValue = '---';
      }
      return defaultValue;
    }
  }
}
